<div class="btn-toolbar" role="toolbar">
    <ng-content></ng-content>
</div>
